// 全局资源管理器
class GlobalResourceManager {
    constructor() {
        this.timers = [];
        this.eventListeners = [];
        this.busSubscriptions = [];
        this.chartInstances = [];
        this.otherDisposables = [];
    }

    // 注册定时器
    addTimer(timer) {
        this.timers.push(timer);
        return timer;
    }
// 在 globalResource.js 中添加
    clearTimersAndEvents() {
        // 清理定时器
        this.timers.forEach(timer => clearInterval(timer));
        this.timers = [];
        // 移除事件监听
        this.eventListeners.forEach(({ target, event, handler, options }) => {
            target.removeEventListener(event, handler, options);
        });
        this.eventListeners = [];
        // 注意：不清理图表和其他资源，保留给组件自行处理
    }
    // 注册事件监听
    addEventListener(target, event, handler) {
        target.addEventListener(event, handler);
        this.eventListeners.push({ target, event, handler });
        return { target, event, handler };
    }

    // 注册 $bus 订阅
    addBusSubscription(event, handler) {
        this.busSubscriptions.push({ event, handler });
        return { event, handler };
    }

    // 注册图表实例（需要 dispose 的）
    addChart(chart) {
        this.chartInstances.push(chart);
        return chart;
    }

    // 注册其他可销毁对象
    addDisposable(obj, disposeMethod) {
        this.otherDisposables.push({ obj, disposeMethod });
    }

    // 清理所有
    clearAll() {
        // 清理定时器
        this.timers.forEach(timer => clearInterval(timer));
        this.timers = [];

        // 移除事件监听
        this.eventListeners.forEach(({ target, event, handler }) => {
            target.removeEventListener(event, handler);
        });
        this.eventListeners = [];

        // 取消所有 $bus 订阅（需要传入 Vue 实例）
        // 这个由组件自己管理，我们在此只是记录，实际清理由组件在 beforeDestroy 中做
        // 也可以提供统一方法，但最好在组件内单独取消

        // 销毁图表
        this.chartInstances.forEach(chart => {
            if (chart.dispose) chart.dispose();
        });
        this.chartInstances = [];

        // 执行自定义销毁
        this.otherDisposables.forEach(({ obj, disposeMethod }) => {
            if (obj[disposeMethod]) obj[disposeMethod]();
        });
        this.otherDisposables = [];
    }
}

// 在 Vue 原型上挂载一个全局实例
const globalResource = new GlobalResourceManager();
export default globalResource;